import axios from 'axios';

const mid = sessionStorage.getItem('mid') || null;
const token = sessionStorage.getItem('token') || null;
const csrfTokenFromMeta = document.querySelector('meta[name="csrf-token"]').content;

export const sendVerification = () => {
    let request = axios.create();
    request.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    request.defaults.headers.common['X-CSRF-TOKEN'] = csrfTokenFromMeta;
    request.defaults.headers.common['X-SEHSEH-Mid'] = mid;
    request.defaults.headers.common['X-SEHSEH-Token'] = token;
    return request.post(`/api/member/send/verification`, {});
};

export const checkMailUsed = (email, csrfToken) => {
    let checkMailUsedRequest = axios.create();
    checkMailUsedRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    checkMailUsedRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken || csrfTokenFromMeta;
    return checkMailUsedRequest.post('/api/member/check/email', {email});
};

export const pauseContract = (data, csrfToken) => {
    let pauseContractRequest = axios.create();
    pauseContractRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    pauseContractRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken || csrfTokenFromMeta;
    pauseContractRequest.defaults.headers.common['X-SEHSEH-Mid'] = mid;
    pauseContractRequest.defaults.headers.common['X-SEHSEH-Token'] = token;
    return pauseContractRequest.patch('/api/member/contract/pause', data);
};

export const forgetPasswordPost = (data, headers, csrfToken) => {
    let forgetPassword = axios.create();
    forgetPassword.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    forgetPassword.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken || csrfTokenFromMeta;
    return forgetPassword.post(`/api/member/password_forget`, data, {headers});
};

export const resetNamePost = (data, csrfToken) => {
    let resetName = axios.create();
    resetName.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    resetName.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken || csrfTokenFromMeta;
    return resetName.post(`/api/member/info`, data);
};

export const resetPasswordPost = (data, csrfToken) => {
    let resetPassword = axios.create();
    resetPassword.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    resetPassword.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken || csrfTokenFromMeta;
    return resetPassword.post(`/api/member/info`, data);
};